import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#2196f3",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#2196f3",
    maxWidth: "fit-content"
  },
}));
